import { FiCopy } from 'react-icons/fi';
import { Button } from '../../../components/ui/button';

interface BtnInsertNotesProps {
  handleInsert: () => void;
}

export const BtnInsertNotes = ({ handleInsert }: BtnInsertNotesProps) => {
  return (
    <Button
      variant='outline'
      size='icon-sm'
      onClick={handleInsert}
      data-tip={'Copy from previous notes'}
    >
      <FiCopy className='w-3 h-3' />
    </Button>
  );
};
